import { styled } from "@mui/material/styles";

import { Image } from "~/components/image/component";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const CrmImageStyled = styled(Image)(({ theme }) => {
  return {
    maxWidth: "100%",
  };
});
